import React from "react";
import { Box, Container } from "@mui/system";
import { Button } from "@mui/material";

export default function Layout1Section4({ acf }) {
  const btnStyle = {
    backgroundColor: "#265DA5",
    color: "#fff",
    borderRadius: "2rem",
    fontSize: "1rem",
    p: "0.5rem 1.5rem",
    mr: "1rem",
    mb: ".35rem",
    "&:hover": {
      backgroundColor: "#3F76BE",
    },
  };

  return (
    <Box
      sx={{
        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            m: "-1rem 0 3rem 0",
          }}
        >
          {acf?.links && acf?.links.length > 0
            ? acf.links.map((link, index) => (
                <Button
                  sx={btnStyle}
                  onClick={() => {
                    console.log(link);
                    window.location = link.link;
                  }}
                >
                  {link.label}
                </Button>
              ))
            : null}
        </Box>
      </Container>
    </Box>
  );
}
